import { Button, ConfigProvider, Result } from "antd";

export interface PreviewErrorStateProps {
  errorCode?: string;
  errorMessage?: string;
  onRetry?: () => void;
}

interface ErrorConfig {
  title: string;
  subtitle: string;
  retryable: boolean;
}

const ERROR_MESSAGES: Record<string, ErrorConfig> = {
  CONVERSION_FAILED: {
    title: "转换失败",
    subtitle: "文档转为 PDF 时出错，请下载后查看或重试",
    retryable: true,
  },
  CONVERSION_TIMEOUT: {
    title: "转换超时",
    subtitle: "文档较大或服务繁忙，请稍后重试或直接下载查看",
    retryable: true,
  },
  CONVERSION_DISABLED: {
    title: "暂不支持预览",
    subtitle: "当前环境未启用文档转换，请下载查看",
    retryable: false,
  },
  UNAUTHORIZED: {
    title: "登录状态已失效",
    subtitle: "请重新登录后再查看该文档",
    retryable: true,
  },
  FORBIDDEN: {
    title: "无权限查看",
    subtitle: "你没有查看该文档的权限",
    retryable: false,
  },
  NOT_FOUND: {
    title: "文档不存在",
    subtitle: "文档可能已被删除或移动",
    retryable: false,
  },
  UNKNOWN: {
    title: "预览失败",
    subtitle: "请稍后重试或下载查看",
    retryable: true,
  },
};

export function PreviewErrorState({
  errorCode,
  errorMessage,
  onRetry,
}: PreviewErrorStateProps) {
  const config = ERROR_MESSAGES[errorCode ?? "UNKNOWN"] ?? ERROR_MESSAGES.UNKNOWN;

  return (
    <ConfigProvider button={{ autoInsertSpace: false }}>
      <Result
        status="warning"
        title={config.title}
        subTitle={errorMessage ?? config.subtitle}
        extra={
          config.retryable && onRetry ? (
            <Button type="primary" onClick={onRetry}>
              重试
            </Button>
          ) : undefined
        }
      />
    </ConfigProvider>
  );
}
